export default {
  categoryInfo: {
    mainTitle: 'Özel (Bireysel) Sağlık Sigortası Nedir?',
    description: {
      content: [
        'Sağlık, hayatta göz önünde bulundurulması gereken en önemli şeylerden birisidir. Çünkü sağlıklı olduğunuzda, istediğiniz aktiviteleri yapma şansınız vardır. Bununla birlikte, sağlığınızı korumak kolay olabilir, ancak bazen bazı hastalıklar öngörülemez olduğu gerçeği değiştirmez.',
        'Özel sağlık sigortası, sağlık bakım masraflarını karşılamaya yardımcı olur. Özel sağlık sigortası, özel hastanelerden alacağınız hizmetleri en uygun biçimde almanızı sağlayan sigorta çeşididir. ',
        'Sunulan sağlık sigortası planları, özel sağlık sigortası şirketleri, sağlık sigortası acenteleri aracılığıyla offline ya da online satın alınabilir. Poliçe kapsamında sunulan tedaviler ve hizmetler, olası sağlık risklerine karşı güvence sağlar.'
      ]
    },
    subContent: {
      title: 'Özel Sağlık Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Hayatımızda kaçınılmaz bir gerçek varsa o da <strong><em><u>sağlığımızdır</u></em></strong>.',
          subList: null
        },
        {
          paragraph:
            'Bir hastalığın tedavisi için doktorunuzu ziyaret edersiniz. Bunun sonucunda hastanede röntgen gibi bazı sağlık masrafları ortaya çıkar. Sağlık durumunuza bağlı olarak yapılacak testler değişiklik gösterir ve hastane masrafları katlanır. ',
          subList: null
        },
        {
          paragraph:
            'SGK kapsamı dışında sağlığınızı farklı sağlık planları ile güvence altına almamışsanız, özel hastaneye ödeyeceğiniz bütçeler cebinizden çıkacaktır. Kısacası özel sağlık sigortanız yoksa bazı tedaviler size büyük bir fatura bırakabilir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Özel Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        company: require('@/assets/company-logos/ak-sigorta.jpg'),
        alt: 'Ak Sigorta',
        name: 'Özel Sağlık Sigortası',
        assurance: 'Aile İndirimi',
        desc: 'İhtiyaca Göre Sağlık Planları'
      },
      {
        id: 2,
        company: require('@/assets/company-logos/allianz-sigorta.jpg'),
        alt: 'Allianz Sigorta',
        name: 'Özel Sağlık Sigortası',
        assurance: 'Kendi Ürününüzü Oluşturun',
        desc: 'Geniş Anlaşmalı Kurum Ağı'
      },
      {
        id: 3,
        company: require('@/assets/company-logos/axa-sigorta.png'),
        alt: 'Axa Sigorta',
        name: 'Özel Sağlık Sigortası',
        assurance: 'Ek Hizmetli',
        desc: 'İndirimli Fiyat'
      },
      {
        id: 4,
        company: require('@/assets/company-logos/demir-sigorta.png'),
        alt: 'Demir Sigorta',
        name: 'Özel Sağlık Sigortası',
        assurance: '2 Farklı Paket',
        desc: 'Bütçeye Uygun Alternatif Plan'
      },
      {
        id: 5,
        company: require('@/assets/company-logos/mapfre-sigorta.png'),
        alt: 'Mapfre Sigorta',
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Geniş Kapsamlı',
        desc: 'Ayrıcalık Dünyası'
      },
      {
        id: 6,
        company: require('@/assets/company-logos/turkiye-sigorta.jpg'),
        alt: 'Türkiye Sigorta',
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Limitli Limitsiz Planlar',
        desc: 'Ömür Boyu Yenileme Garantisi'
      }
    ]
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Özel Sağlık Sigortası Avantajları (Faydaları) Nelerdir?',
      content: [
        {
          paragraph:
            'Sağlık sigortası sektöründe, neyi aradığınızı anlamak önemlidir.',
          subList: null
        },
        {
          paragraph:
            'İşlemlerinizi zorlaştıracak birçok jargon vardır. Özel sağlık sigortası yaptırmak istiyorsanız ve kendi başınıza en uygun özel sağlık sigortası fiyatını arıyorsanız, incelemeniz gereken bazı şartlar olduğunu ilk etapta bilmelisiniz.',
          subList: null
        },
        {
          paragraph:
            'Bireysel ya da aile planı arıyorsanız, özel sağlık sigortası kapsamında sunulan teminatları incelemelisiniz. Fayda sağlayan durumların neler olduğunu bilmediğiniz sürece poliçenin amacını anlayamaz ve ihtiyacınız olup olmadığını bilemezsiniz.            ',
          subList: [
            'Özel sağlık sigortasının tercih edilmesinin ilk nedeni, limitsiz tedavi seçeneği sunulmasıdır.',
            'İstediğiniz hastaneyi ve doktoru seçmekte özgür olursunuz.',
            'Poliçe kapsamında kendinizi özel hissedersiniz.',
            'Yatış gerektiren durumlarda özel oda tercih etme hakkına sahip olursunuz.',
            'Daha hızlı teşhis, daha hızlı tedavi sağlar. Poliçe kapsamında sunulan özel hastanelerden kaliteli hizmeti en hızlı şekilde alırsınız.',
            'Hastanede tedavi gördüğünüz sürece ihtiyacınız olan her erişime sahip olacaksınız.',
            'Özel hastanelerin en yeni ilaç ve tedavi prosedürlerine daha fazla erişimi vardır, bu da çok daha etkili tedavi alabileceğiniz anlamına gelmektedir.',
            'Bireysel sağlık poliçelerinin yanı sıra aile planları da sunulmaktadır. Böylece tek bir poliçe de ailenizin de sağlığını güvence altına alabilirsiniz.',
            'Anne adayları, teminatlar arasında sunulan doğum teminatını seçme hakkına sahip olur. Böylece doğum sürecini ve yeni doğan bebeğini de güvence altına alabilir.',
            'Özel sağlık sigortası poliçesinde ekstra vergi indirim hakkı da bulunmaktadır. Ödemiş olduğunuz primleri vergiden düşebilirsiniz.'
          ]
        },
        {
          paragraph:
            'Özel sağlık bakım hizmetlerinin size nasıl fayda sağlayacağını anlamak, size gelecek için en iyi bakım seçeneklerini seçmeniz için gereken kaynakları sağlayacaktır.          ',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            '<strong>Özel sağlık sigortası fiyatları</strong> yaşa ve sağlık durumuna göre belirlenmektedir. Kriterler dikkate alınarak erken yaşta yaptırılan sağlık sigortası, adaylara daha fazla güvence sağlar. Sigorta şirketlerinin belirlemiş olduğu standartlarda yaş sınırları farklılık göstermektedir.',
          subList: null
        },
        {
          paragraph:
            'Ortalama özel sağlık sigortası <strong>yaş sınırı 65’tir</strong>. Maksimum yaş sınırı bazı sigorta şirketlerinde 55 olurken bazı sigorta şirketlerinde 60 olabilmektedir.',
          subList: null
        },
        {
          paragraph:
            'Yaş ilerledikçe, ortaya çıkabilecek sağlık sorunları arttığı için poliçe primleri de buna kıyasla artışa gider. Olası daha yüksek maliyetleri göz önünde bulundurmalı ve erken yaşta sağlık sigortası almaya özen göstermelisiniz.',
          subList: null
        },
        {
          paragraph:
            'Mümkün olduğu kadar erken bir zamanda sağlık sigortası planı satın almak, yaşlılık döneminde size prim konusunda yardımcı olabilir. Bazı sigorta şirketleri, belirli bir yaştan önce planla birlikte olanlara belirli bir yaştan sonra sabit prim sunabilir. Ancak, belirtilen yaştan sonra bir plan alırsanız, primleriniz büyük olasılıkla yıllık bazda artacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında sunulan planlar sigorta şirketlerine göre farklılık göstermektedir.',
          subList: null
        },
        {
          paragraph:
            'Plan genelinde sunulan teminatlar arasında yatarak tedavi teminatı ve ayakta tedavi teminatı yer almaktadır. Bunun dışında ise doğum teminatı ek olarak sunulmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Sağlığınızı güvence altına almak için hemen başvuru formumuzu doldurun ve sigorta şirketlerinin paket özellikleri hakkında bilgi alın.',
          subList: null
        }
      ]
    },
    {
      title: 'En Kapsamlı Özel Sağlık Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Her sağlık sigortası, farklı düzeylerde poliçeler sunar. En temelde, özel sağlık sigortası, hastalanırsanız özel tedavi masraflarınızı karşılar. Bununla birlikte, özel sağlık sigortası her durumu kapsamaz ve şirketten şirkete farklılık gösterir.',
          subList: null
        },
        {
          paragraph:
            'Genel olarak, daha pahalı olan poliçeler daha geniş bir hizmet yelpazesini kapsarken, daha düşük maliyetli poliçeler özel bir hastanede hangi hizmetlerin karşılanacağını sınırlayacaktır.',
          subList: null
        },
        {
          paragraph:
            'Sağlık ihtiyaçlarınızı göz önünde bulundurarak size en uygun olan kapsamı satın almanız gerekir.',
          subList: null
        },
        {
          paragraph:
            'Şirketler arası farklılık gösteren planları en doğru şekilde değerlendirmeniz adına Alo Kasko uzmanları sizin yanınızda.',
          subList: null
        }
      ]
    },
    {
      title:
        'Özel Sağlık Sigortası Kapsamı Dışında Kalanlar Durumlar Nelerdir?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortasının karşılamadığı durumlar arasında ilk olarak geçmişten gelen sağlık sorunları olduğunu bilmelisiniz. Bunun dışında özel sağlık sigortası teminatlarının bazılarında bekleme süresi bulunur. Poliçe kapsamında bekleme süresinin karşılanması gerekir. Bekleme süresi olan teminatın süresi dolmadan gerçekleşecek işlemler karşılanmaz.            ',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'İhtiyaç anında kaliteli ve hızlı sağlık hizmeti sağlayan özel sağlık sigortası teminatları her planda farklı olmaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak tedavi teminatı kapsamına dâhil olan durumlar:</u></em></strong>',
          subList: [
            'Kemoterapi ',
            'Yoğun bakım,',
            'Radyoterapi',
            'Suni uzuv, ',
            'Refakatçi'
          ]
        },
        {
          paragraph: 'Gibi birçok sağlık harcaması karşılanır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Ayakta tedavi kapsamında değerlendirilen durumlar:</u></em></strong>',
          subList: [
            'Fizik tedavi, ',
            'Röntgen,',
            'Radyoterapi',
            'Muayene, ',
            'Tahlildir'
          ]
        },
        {
          paragraph:
            '**Sunulan ek teminatlar ise sigorta şirketlerine göre değişmektedir. En doğru teminatları poliçenize eklemek için teklif almayı unutmayınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Tam Kapsamlı Özel Sağlık Sigortası Doğum Paketi Nedir?',
      content: [
        {
          paragraph:
            '<strong>Özel sağlık sigortası doğum paketi</strong>, hamilelik sürecinde anne adayı ve bebek için hayati önem taşır. Doğum sigortası ya da doğum teminatı kapsamında sunulan birçok plan vardır. Bu noktada öncelik anne adayının ihtiyaçları ve doğum sürecidir. Özel sağlık sigortası hamilelik, doğum sırasında ve bazı durumlarda beklenmedik tıbbi durumlarla karşılaşmanız sonucunda ve doğum sonrası bakım sırasında size mali destek sağlayabilir.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası (hamilelik)  doğum paketi ile birlikte gelen “<strong><em><u>bekleme süresi</u></em></strong>” bulunur. Bekleme süreleri ise sigorta şirketlerine göre farklılık gösterir. Bu süreler 5 ay ile 12 ay arasında değişiklik göstermektedir. Özellikle planlı gebelik süreçlerinde özel sağlık sigortası yaptırarak doğum teminatı satın almanız size avantaj sağlar. Poliçe kapsamında yer alan bekleme süresi tamamlanmadan hamilelik başlarsa, giderler karşılanmaz.',
          subList: null
        },
        {
          paragraph:
            'Doğum teminatlarını değerlendirirken; ne kadar doğum öncesi ve sonrası hizmete ihtiyacınız olacak, doğum ve tedavi odalarınızın kalitesi, doğum yapmak istediğiniz hastane, doğum öncesi ve sonrası tedavi dahil olmak üzere faydaların kapsamını kontrol etmeniz son derece önemlidir. Yeni doğan bebeğinizi sağlık sigortası kapsamında doğumdan sonra güvence altına almak isterseniz, poliçeniz buna izi verir.',
          subList: null
        },
        {
          paragraph:
            'Hamilelik sürecini güvence altına alan doğum teminatı, doğum masrafları ödemek zorunda kalmamanızı sağlamanın harika bir yoludur.',
          subList: null
        },
        {
          paragraph:
            '<strong><u>AloKasko</u></strong> sigorta danışmanları, bir annelik sigortası planının tüm ayrıntılarını anlamanıza yardımcı olabilir. Sigorta şirketlerinin mevcut seçeneklerini listeleyebilir ve hatta size en uygun olan bir poliçe önerebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Hamileyken Özel Sağlık Sigortası Yapılır Mı?',
      content: [
        {
          paragraph:
            'Hamileyken doğum sigortası satın alabilirsiniz. Fakat tercih edebileceğiniz doğum teminatlı poliçe özel sağlık sigortası kapsamında değildir. Özel sağlık sigortası doğum paketinde bekleme süresi mevcuttur.',
          subList: null
        },
        {
          paragraph:
            'Hamileyseniz ve sigortasızsanız, düşük maliyetli paket seçeneklerinden yararlanmak için başvuru formunu doldurabilir, sigorta danışmanlarımızdan bilgi alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Doğum (Hamilelik) İçin Özel Sağlık Sigortası Yaptırmak Mantıklı Mı?',
      content: [
        {
          paragraph:
            'Birçok sağlık sigortası poliçesi, acil durumlar veya analıkla ilgili komplikasyonlar için gereken özel sağlık bakım masraflarını karşılayabilir. Anne adayları sağlık sigortası yaptırırken doğum teminatını tercih etmelidir. Olası sağlık sorunları ve sağlık harcamaları göz ardı edilemez.',
          subList: null
        },
        {
          paragraph:
            'Her anne en iyi hastanede doğum sürecini tamamlamak ve bebeğini kucağına sağlıkla almayı ister. Bunun dışında anne adaylarının hamilelik sürecinde olası streslerden uzak kalması da son derece önemlidir. Tercih edeceği hastaneyi, doktoru ve masrafları düşünmek anneyi ve bebeği strese iter.',
          subList: null
        },
        {
          paragraph:
            'Bir sigorta uzmanı, poliçenin ayrıntılarını ve neyin kapsam dahilinde olup olmadığını anlamanıza yardımcı olabilir, böylece en çok ihtiyacınız olduğunda kaliteli sağlık hizmetini nasıl  alacağınızı bilmenin huzurunu yaşarsınız.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>0216 371 67 77</u></em></strong> numaralı telefondan bize ulaşın veya bir araştırma yapmak için başvuru formuna bilgilerinizi bırakın ve sizi deneyimli bir özel sağlık sigortası danışmanına yönlendirelim.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Doğumdan Ne Kadar Önce Yapılmalı?',
      content: [
        {
          paragraph:
            'Sigorta yaptırırken zamanlama önemlidir: Özellikle doğumu kapsayan özel sağlık sigortası yaptırmak istiyorsanız.',
          subList: null
        },
        {
          paragraph:
            'Hamile kalmayı düşünenlere veya halihazırda hamile olanlara nazik bir hatırlatma olarak, sigorta poliçeleri, halihazırda veya hemen hamile kalmak üzere olan herkesin doğum masraflarıyla ilgili kapsamı <strong><em><u>reddedebilir</u></em></strong>.',
          subList: null
        },
        {
          paragraph:
            'Çoğu durumda, sigortacılar hamilelik, doğum ve / veya yenidoğan teminatını karşılamaya başlamadan önce yaklaşık 5-12 aylık annelik teminatına sahip olmanızı yani bekleme süresini tamamlamanızı talep etmektedir.',
          subList: null
        },
        {
          paragraph:
            'Hamileyseniz ve doğum sigortası yaptırmak istiyorsanız, özel sağlık sigortası kapsamında olmayan diğer paketleri değerlendirebilirsiniz. Ama bu noktada bilmeniz gereken en önemli durum paket seçeneklerinin dar olduğudur. Bu sebeple henüz hamile değilseniz ve planlama yapıyorsanız size en uygun olabilecek bekleme süreli paketleri karşılaştırınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Doğumu Ne Zaman Karşılar?',
      content: [
        {
          paragraph:
            'Doğum teminatı bulunan poliçelerde masraflar, bekleme süresinin tamamlanması sonucunda başlayan gebeliklerde karşılanır.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası kapsamında olmasa bile halihazırda hamileyken sağlık sigortası yaptırmak mümkündür, ancak çoğu durumda ödeme almaya hak kazanmak için hamile kalmadan önce poliçeyi güvence altına almış olmanız gerekir.',
          subList: null
        },
        {
          paragraph:
            'Bir finans danışmanı, poliçe zamanlamasının ayrıntılarını anlayacak, sigorta kapsamının derinlemesine bir karşılaştırmasını yapabilir veya hamileliği içeren sağlık sigortası almak için sigorta şirketinizi bulmanıza yardımcı olabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortasına sahip olmak genellikle size daha fazla tedavi ve tesis seçeneği sunar. Sağlık sigortası ile poliçeniz için kararlaştırılan primi peşin ya da aylık ücretle ödersiniz.              ',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası, poliçe priminin ödenmesi durumunda başlar. Karşılaştırma yaptığınız şirketin teminatlarını ve primini uygun bulmanız sonucunda sunulan teklifi onaylamanız gerekir. Onay durumunda teklifiniz poliçeleştirilir ve size iletilir. Taksit seçeneğinden yararlanmışsanız, ilk primi ödersiniz ve teminatlardan yararlanmaya başlarsınız.',
          subList: null
        },
        {
          paragraph:
            '*** Poliçenizi satın almanız durumunda her teminattan hemen yararlanamazsınız. Bazı teminatların bekleme süresi bulunur ve bunların tamamlanması gerekir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Şartları Şirketlere Göre Değişir Mi?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında belirlenen özel şartlar sigorta şirketlerine göre değişiklik göstermektedir.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası özel şartlarında belirtilen konular son derece nettir. Bu doğrultuda açıkça poliçenin kapsamı, geçerli olan teminatlar ve limitler, teminat dışı tutulan haller, hasar ödeme şartları, ömür boyu yenileme gibi konular yer alır.',
          subList: null
        },
        {
          paragraph:
            'Tercih edeceğiniz özel sağlık sigortasından en iyi şekilde yararlanabilmek için detaylı inceleme yapmalısınız. Hangi durumlarda, hangi teminatlarda yararlanacağınızı bilmek ve hizmet alacağınız anlaşmalı hastaneleri öğrenmek size avantaj sağlayacaktır.',
          subList: null
        },
        {
          paragraph:
            'Fiyat teklifi aldıktan sonra gerekli şartları özenle incelemeli ve poliçe döneminizde sorun yaşamamak için uzmanlarımızdan kapsamlı bilgi almanızı öneriyoruz.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Genel Şartları Nelerdir?',
      content: [
        {
          paragraph:
            'Bireysel sağlık sigortası 1 yıllık yapılan sigorta poliçesidir. Bu dönem içerisinde kişinin hastalanma ve yaralanma risklerini güvence altına alır. Örneğin meydana gelen bir kaza sonucunda tedavi giderlerinizi poliçe teminat limitleri doğrultusunda karşılar.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası genel şartları geniş kapsamlıdır. Poliçe genel şartları, özel şartlar gibi değişiklik göstermez. Sağlık sigortası genel şartları tüm şirketler için aynıdır.',
          subList: null
        },
        {
          paragraph:
            'Poliçe özel şartları hakkında bilgi sahibi olduğunuz kadar genel şartlar hakkında da bilgi sahibi olmalısınız.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Özel sağlık sigortası genel şartları</u></em></strong> kapsamında işlenen konular:',
          subList: [
            'Teminat Dışı Kalan Haller',
            'Aksine Sözleşme Yoksa Teminat Dışında Kalan Haller',
            'Sigortanın Coğrafi Sınırı',
            'Sigortanın Başlangıcı ve Sonu',
            'Sigorta Ettirenin Sözleşme Yapılırken Beyan Yükümlülüğü',
            'Sigorta Süresi İçinde İhbar Yükümlülüğü',
            'Primin Ödenmesi ve Sigortacının Sorumluluğunun Başlaması',
            'Rizikonun Gerçekleşmesi Halinde Sigortalının Yükümlülükleri',
            'Masrafların Tespiti',
            'Tazminatın Sonuçları ve Sigortacının Halefiyet Hakkı',
            'Müşterek Sigorta',
            'Sırların Saklı Tutulması',
            'Tebliğ ve İhbarlar',
            'Yetkili Mahkeme',
            'Zaman Aşımı.'
          ]
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Hasta Bilgi Formu Nedir?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası satın alan kişiler ilgili hastaneye muayene için gittiklerinde, hasta bilgi formu doldurması gerekir. Hasta bilgi formu, sağlık hizmeti alabilmeniz için gereklidir. Kısacası ilgili doktor ve sigortalı tarafından doldurulan belgeye verilen isimdir.',
          subList: null
        },
        {
          paragraph:
            'Hasta bilgi formu, hastanın bilgilerini, tetkik sonuçlarını, fiziki muayene bulgularını içerir. Form da talep edilen bilgiler tam ve eksiksiz doldurulmalıdır.',
          subList: null
        },
        {
          paragraph:
            '*** Acil durumlar dışında yapılacak tedavi ve ameliyatlar için en az 24 saat önceden provizyon alınması önerilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Aile Paketi Nedir, Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında sunulan aile paketleri, sigortalılara prim avantajı sağlar. Sağlığınızı güvence altına almak istediğiniz nokta da sigorta şirketlerinin fiyat tekliflerini inlemeye başlayacaksınız. Poliçe kapsamında sadece kendi sağlığınızı değil, ailenizin sağlığını da güvence altına alma imkânınız bulunur.',
          subList: null
        },
        {
          paragraph:
            'Aile sağlık sigortası paketi, özel tıbbi sağlık bakımı için tüm aileyi kapsayan poliçedir. Bunun dışında aile sağlık sigortasına özel indirimlerde uygulanmaktadır. Primlerden tasarruf etmek istiyorsanız geniş kapsamlı aile paketlerini değerlendirebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Ailenizde bulunan her kişi için ayrı sağlık sigortası yaptırmak yerine, aşağıdakileri kapsayacak bir aile poliçesi yaptırabilirsiniz:',
          subList: ['Kendiniz,', 'Eşiniz,', 'Çocuklarınız.']
        },
        {
          paragraph:
            'Aile sağlık sigortasından faydalanmak istediğiniz durumda da poliçede yer alan herhangi bir özel tıbbi tedavi için talepte bulunabilirsiniz. Daha sonra tedavi masraflarının bir kısmını veya tamamını sigorta şirketiniz öder.',
          subList: null
        },
        {
          paragraph:
            'Her sağlık sigortası planı farklı bir aralığı kapsar: Talepte bulunabileceğiniz semptomlar, hastalıklar ve yaralanmalar teminatlara göre değişir.',
          subList: null
        },
        {
          paragraph:
            'Kendiniz, çocuklarınız ya da eşiniz için sağlık sigortasına ihtiyacınız olduğunu düşünüyorsanız, <strong><em><u>alokasko.com</u></em></strong> uzmanları size yardımcı olabilir. Anlaşmalı olduğumuz sigorta şirketleri doğrultusunda size özel sunacağımız çeşitli seçenekler mevcuttur. Sağlık sigortası satın alırken göz önünde bulundurmanız gereken en önemli adım ihtiyaç kapsamında teminat seçmenizdir. Bunun dışında hangi şirketten sağlık güvencesi alıyorsanız anlaşmalı sağlık kuruluşlarını incelemelisiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Özel Sağlık Sigortası Ömür Boyu Yenileme Garantisi Nedir?        ',
      content: [
        {
          paragraph:
            'Sağlık sigortası söz konusu olduğunda, ömür boyu yenileme garantisi tam olarak isminden anlaşıldığı gibidir. Yaşınız veya sağlık koşullarınız ne olursa olsun sağlık sigortanızın yenileneceğinin garantisidir. Bu, size ciddi bir hastalık veya kronik tıbbi durum teşhisi konulursa, sağlık sigortası şirketinizin sigortanızın yenilenmesini reddedemeyeceği veya sizi teminatsız bırakmayacağı anlamına gelir.',
          subList: null
        },
        {
          paragraph:
            'Ömür boyu yenileme garantisine hak kazanmak isteyen adaylar, aynı sigorta şirketinden poliçelerini <strong><em>en az 3 yıl</em></strong> düzenli olarak yenilemelidir. İlk poliçenizi tercih ederken sigorta şirketinin şartlarını incelemeli ve ömür boyu yenileme hakkı sunup sunmadığını kontrol etmelisiniz. Her aday bu hakkı kazanamayabilir. Düzenli poliçenizi yenilemeniz sonucunda sigorta şirketi yenileme dönemlerini ve sağlık durumunuzu kontrol eder ve bunun sonucunda belirlenen oranlara göre bu hakkı size sunabilir.',
          subList: null
        },
        {
          paragraph:
            'Ömür boyu yenileme garantisi, ne olursa olsun aynı sağlık sigortası kapsamında size garantili teminat sağlar. Teminatınıza istediğiniz kadar devam etme özgürlüğüne sahip olursunuz.',
          subList: null
        }
      ]
    },
    {
      title:
        'En Uygun Özel Sağlık Sigortası Kapsamı Nasıl Belirlenir?          ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası seçmek karmaşık bir süreç gibi gelebilir. Aslında, hangi ürünlerin en büyük faydayı vereceğini ilk etapta bilemezsiniz.  Biraz araştırma ve planlamayla, genellikle sizin için uygun olan sağlık sigortasını seçebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası poliçenize karar verirken göz önünde bulundurmanız gereken bazı noktalar vardır:',
          subList: [
            'Özel sağlık sigortası karmaşık bir üründür, bu nedenle, özellikle tıbbi sorunlarınız varsa veya belirli hastalıklar için geniş kapsamlı sigortaya ihtiyacınız varsa, bir danışmanla konuşmak en iyisidir.',
            'En doğru teminatları seçebilmek için sağlık durumunuzu göz önünde bulundurmalısınız.',
            'Poliçe fiyatlarını en ucuza indirmek için önemli teminatları görmezden gelmeyin.',
            'Sağlık sigortası tekliflerini incelerken şirketlerin anlaşmalı hastane listesini de incelemelisiniz.',
            'Ek ödeme yapmamak için poliçe kapsamında yer alan bekleme sürelerini değerlendirmelisiniz.'
          ]
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Bekleme Süresi Nedir?',
      content: [
        {
          paragraph:
            'Sağlık sigortalarının müşterileri için fiyatlandırmayı adil hale getirmek için bekleme süreleri vardır. Sigortacılar genellikle, yeni müşterileri için bekleme süresi bulunan teminatlar iletebilir. Bekleme süreleri her teminat için geçerli değildir.',
          subList: null
        },
        {
          paragraph:
            'Bekleme süreleri genellikle önceden var olan bir rahatsızlığın sonucu olarak ihtiyaç duyduğunuz hastanede tedavi alabilmeniz için uygulanır. Bunun dışında aileden gelen bir hastalık söz konusuysa yine bekleme süresi ile karşılaşabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası fiyatlarını değerlendirirken aynı zamanda teminatlara eklenen bekleme sürelerini de dikkate almalısınız. Satın aldığınız sigorta poliçesi kapsamında bir bekleme süresi yer alıyorsa, süre tamamlanmadan o hizmetten yararlanamazsınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Bekleme Süresi Ne Kadar?',
      content: [
        {
          paragraph:
            'Bekleme süreleri, ihtiyaç duyduğunuz tedaviye ve sahip olduğunuz plana göre değişir. Genel olarak bekleme süresi bulunan bazı durumlar:',
          subList: [
            'Burun, geniz eti, sinüzit, bademcik, işitme kusuru kulak tüpü takılması gibi durumlar.',
            ' Diz, trigger finger, her türlü tuzak nöropati, ganglion, kistik higroma.',
            'Tüm organ nakli ihtiyaçları,        ',
            'Katarakt ameliyatı ve glokom, ',
            'Omurga ve disk hastalıkları ile ilgili ameliyatlar, faset denervasyon, sinir blokajı,',
            'Rahim, yumurtalık, sistorektosel, bartholin kisti,    ',
            'Siğil, lipom, kist sebase (yağ bezesi),',
            'Üriner sistem taşı kırılması (ESWL) ve cerrahisi, hidrosel, prostat.',
            'Varis, anorektal hastalıklar (hemoroid, anal fissür, fistül, anal abse, vb.).',
            'Sinüs pilonidalis (kist dermoid sakral),',
            'Kist hidatik, her türlü fıtık (karın içi organ fıtığı, vb.).',
            'Safra kesesi, tiroid bezi, ve meme hastalıkları durumlarında bekleme süresi talep edilir.'
          ]
        },
        {
          paragraph:
            '***Özellikle bu durumlardan yararlanmak isteyen sigortalılar inceleme ve değerlendirme yaparak poliçelerini onaylamalıdır. Bekleme süresi hakkında bilgi almadan satın alacağınız poliçeniz kapsamında mağdur olmamak için bilgi almanız önemlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Anlaşmalı Hastaneler Nedir?        ',
      content: [
        {
          paragraph:
            'Anlaşmalı hastaneler, satın aldığınız ya da satın almayı düşündüğünüz sigorta şirketinin anlaşmalı olduğu, poliçe döneminde hizmet alacağınız kurum veya kuruluşlara verilen isimdir.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası poliçesinin sunduğu tüm özellikleri göz önünde bulundurduğunuzdan ve sadece poliçenin prim tutarına dayalı bir karar vermediğinizden emin olmalısınız. Sağlık sigortası kapsamının gerekliliğini değerlendirerek, bilinçli karar vermeniz adına anlaşmalı sağlık kuruluşlarını da incelemelisiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Hangi Hastanelerde Geçerli?',
      content: [
        {
          paragraph:
            'Sağlık sigortası kapsamında hizmet alınabilecek hastaneler son derece geniştir.',
          subList: null
        },
        {
          paragraph:
            'Her sigorta şirketinin anlaşmalı hastanesi farklı olabilir. Bu sebeple tercih ettiğiniz şirketin hangi hastanelerinden hizmet alabileceğinizi öğrenmek için sigorta danışmanlarımıza ulaşabilir ya da sigorta şirketinizin web sitesini ziyaret edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Özel Sağlık Sigortası İle Tamamlayıcı Sağlık Sigortası Arasındaki Fark Nedir?        ',
      content: [
        {
          paragraph:
            'İhtiyaçlarınızı karşılayan bir sigorta planı seçmek çok zor olabilir. İlk adım, tamamlayıcı sağlık sigortası ve özel sağlık sigortası arasındaki farkı anlamaktır. Sizin için hangisi doğru?              ',
          subList: [
            'Tamamlayıcı sağlık sigortası poliçeleri hastane masraflarını ve giderlerini ek ücret talep etmeden karşılarken, özel sağlık sigortası poliçeleri belli bir oran dâhilinde karşılar',
            'Özel sağlık sigortası yaptırmak istediğinizde herhangi bir sosyal güvence aranmaz. Fakat tamamlayıcı sağlık sigortası yaptırmak isteyen adaylarda aranan ilk şart SGK güvencesinde yer almasıdır.',
            'Özel sağlık sigortasının anlaşmalı hastaneler listesi tamamlayıcı sağlık sigortasına göre daha geniştir.',
            'Özel sağlık sigortası kapsamında sunulan yurt dışı teminatı ile yurt dışından hizmet alabilme hakkınız vardır. Fakat tamamlayıcı sağlık sigortasında bu ek teminat bulunmaz. ',
            'Alınacak hizmetler özel sağlık sigortasında daha kapsamlıdır, bu sebeple sigorta primleri tamamlayıcı sağlık sigortasına göre daha pahalıdır'
          ]
        }
      ]
    },
    {
      title: 'Bebek İçin Özel Sağlık Sigortası Nedir?        ',
      content: [
        {
          paragraph:
            'Bebek için özel sağlık sigortası, doğumdan sonra güvence sağlar.  Doğum gerçekleştikten sonra bebeğinizi sağlık sigortası kapsamına almak istiyorsanız 14 gün beklemeniz gerekmektedir. Bunun sebebi ortaya çıkacak sağlık sorunlarının tespitinin yapılmasıdır.              ',
          subList: null
        },
        {
          paragraph:
            'Yeni doğan bebekler sağlık sigortası kapsamına alınmaktadır. Sigorta şirketleri arasında ürün isimleri “<strong><em>yeni doğan sigortası</em></strong>”, “<strong><em>hoşgeldin bebek sigortası</em></strong>” gibi isimlerle adlandırılmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Bebek sağlık sigortası yaptırarak yeni doğan bebeğinizi güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Bebek sağlık sigortası fiyatları; bebeğinizin cinsiyetine, yaşadığı ile ve sağlık durumuna göre belirlenecektir.',
          subList: null
        }
      ]
    },
    {
      title: 'Çocuk İçin Özel Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Çocuk sağlık sigortası, çocuğunuzun hastalanması durumunda ihtiyaç duyulan tedavi masraflarını karşılayacak şekilde tasarlanmıştır.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası çocuğunuzun tedavisi için ödeme yapmanıza yardımcı olur. 18 yaş altındaki çocuklar, aile sigortası kapsamında ebeveynlerinin sigorta poliçesine alınabilir, bu şekilde sağlık harcamaları (belirlenen limitler doğrultusunda) özel sağlık sigortası tarafından karşılanabilir.',
          subList: null
        },
        {
          paragraph:
            'Herhangi bir sigorta poliçesinde olduğu gibi, özel sağlık sigortanızın kapsamadığı herhangi bir istisnaya da dikkat etmelisiniz. Özel sağlık sigortası genellikle poliçeyi satın aldığınızda ne kadar küçükseniz o kadar ucuzdur, bu nedenle çocuğunuz için sigorta yaptırmanın daha ucuz olacağını bilmelisiniz.',
          subList: null
        },
        {
          paragraph:
            'Karşılaştırma aracımızı kullanarak çocuklarınızı ve / veya eşinizi içeren sağlık sigortası için bir aile poliçesi için fiyat teklifi alabilirsiniz. Uzmanlarımız, çeşitli çocuk sağlık sigortası planlarından hangisinin aileniz için doğru olacağına karar vermenize yardımcı olabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğum İçin Özel Sağlık Sigortası Yaptırmak Neden Önemlidir?',
      content: [
        {
          paragraph:
            'Hamileliğin stresli bir dönem olabileceği bir sır değil. Pek çok bilinmeyen var, ancak doğum deneyimi hakkında, kamusal veya özel sistemden geçip geçmeyeceğiniz gibi bilinçli kararlar vermek, zihninizi rahatlatmanıza yardımcı olabilecek şeylerden biridir.',
          subList: null
        },
        {
          paragraph:
            'Hayattaki her şey plana göre gitmez ve bebeğinizin doğumu da bir istisna değildir. Ancak hamileliğiniz sırasında ne tür bir bakım alacağınızı kontrol edebilirsiniz. <strong><em><u>Hamilelik sigortası</u></em></strong>, bir sağlık sigortası poliçesinin maliyetine büyük ölçüde katkıda bulunur. Bununla birlikte, birçok kişi, gönül rahatlığı ve sunduğu seçim için ekstra maliyetin buna değdiğini düşünüyor.',
          subList: null
        },
        {
          paragraph:
            'Her sağlık sigortası ürünü farklıdır, bu nedenle sağlık sigortanızı doğum için kullanma olasılığınız varsa, poliçenize hamilelik ve doğumun dâhil olup olmadığını kontrol edin. Sağlık sigortası kapsamında bebek sahibi olmayı planlıyorsanız vaktinden önce düşünmeniz gerekir. Özel salık sigortası hamilelik ve doğum teminatından yararlanabilmeniz için 5 ila 12 aylık değişiklik gösteren bekleme süresi karşınıza çıkacaktır.',
          subList: null
        },
        {
          paragraph:
            'Sigorta şirketlerinin sunmuş olduğu poliçeler bazında karşılaştırma yaparak hangisini tercih edeceğinizi seçebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Hamilelik yardımına ihtiyacınız var mı? Bilgilerinizi form aracığıyla bizlere iletebilirsiniz. Sigorta uzmanlarımız seçeneklerinizi görüşmek için sizi arayacaktır, böylece hamileliğiniz için mükemmel poliçeyi bulmanıza yardımcı olabiliriz.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Nasıl Yapılır?          ',
      content: [
        {
          paragraph:
            'Farklı sağlık sigortası planları vardır ve bu planların her birinin bir takım benzersiz özellikleri vardır. Fiyat karşılaştırması yaparken en iyi sigorta planını seçmek amacınız olmalıdır.',
          subList: null
        },
        {
          paragraph:
            'Kendi sağlık sigortası poliçenizi almak, bir işverenin planına kaydolmak kadar kolay değildir, ancak en azından aldığınız plan üzerinde kontrolünüz vardır. Neye ihtiyacınız olduğunu anladıktan ve sağlık sigortası planlarını tanımlamak için kullanılan terminolojiye aşina olduğunuzda, araştırmanız daha kolay hale gelecektir. Mevcut seçeneklerin sayısıyla, muhtemelen ihtiyaçlarınızı ve bütçenizi karşılayan bir plan bulabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası yaptırmak için online telif formumuzu doldurmanız yeterlidir. Bilgilerinizi ilettikten sonra fiyat ve teminat karşılaştırmasını uzmanlarımız ile yapabilir, en iyi sağlık sigortasını kolaylıkla seçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Nerede Yaptırılır?        ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası satın almak söz konusu olduğunda birkaç seçeneğiniz vardır.',
          subList: null
        },
        {
          paragraph:
            'Coğrafi bölgenizdeki acenteleri ziyaret edebilir ya da online teklif ile internet üzerinden geniş kapsamlı sağlık sigortası fiyatı alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com fiyat araştırması yapan müşterilerini yormadan kolayca fiyat almasını, karşılaştırma yapmasını, tercih ettiği teminat türüne ve ödeyebileceği kesintiye göre mevcut seçeneklere göz atmasını sağlar. Üstelik sağlık sigortası fiyatı isteyen müşterilerine özel sigorta uzmanı atar ve en iyi poliçeyi sunar.',
          subList: null
        },
        {
          paragraph:
            '*** Web sitemiz, pazar yeri dışında satın alınabilecek özel planlar hakkında bilgiler içerir. Size özel sunacağımız fiyatları online alın, avantajlı primlerden yararlanın.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Yapan Şirketler (Firmaları)  Hangileridir?',
      content: [
        {
          paragraph:
            'Kişisel sağlık, muhtemelen uğraşacağımız en önemli şeydir. Özel sağlık sigortası yaptırırken tercih ettiğimiz sigorta şirketini de değerlendirmeliyiz. En iyi sigorta şirketini bulmayı hedef edinebilirsiniz. İyi kavramı sigortalıdan sigortalıya değişiklik gösterdiği gibi poliçe kapsamına göre belirlenir.              ',
          subList: null
        },
        {
          paragraph:
            'Birçok sigorta şirketi, eklentileri olan paketler sunar. Bu, değişen sağlık bakımı ihtiyaçlarınıza uyacak şekilde poliçelerinizi değiştirmelerine yardımcı olabilir.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com üzerinden sağlık sigortası teklifi aldığınızda size özel fiyat sunacağımız anlaşmalı sigorta şirketlerimiz:',
          subList: [
            'Ak Sigorta',
            'Allianz Sigorta',
            'Axa Sigorta',
            'Demir Hayat',
            'Groupama Sigorta',
            'Mapfre Sigorta',
            'Türkiye Sigorta'
          ]
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Nasıl Kullanılır?',
      content: [
        {
          paragraph:
            'Poliçe süresi içinde hastalanırsanız veya yaralanırsanız, özel tıbbi tedavi, testler ve ameliyat masraflarınızı sağlık sigortanız karşılar.',
          subList: null
        },
        {
          paragraph:
            'Sigorta şirketinin anlaşmalı hastanesinden randevu alarak gitmeniz durumunda poliçe teminatları ve limitleri baz alınarak size hizmet sağlanır.',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortanız için prim adı verilen aylık bir bütçe ödersiniz. Sigortanız, poliçe aktifken kapsadığı bir tedaviye ihtiyacınız varsa aldığınız hizmet doğrultusunda karşılanır.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Yenileme Numarası (No) Nedir?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası poliçeleri 1 yıllık yapılan sigorta türüdür.',
          subList: null
        },
        {
          paragraph:
            'Poliçenizi satın aldığınız zaman üzerinden başlangıç ve bitiş tarihleri yer alır. Bitiş tarihi gelen sağlık sigortası poliçeleri ise isteğe bağlı yenileme yaptırılır ve sağlık hizmeti almaya devam edilir. Sağlık sigortası poliçesinin bitiş tarihi itibari ile tekrar başlamasına da “yenileme” ismi verilir.              ',
          subList: null
        },
        {
          paragraph:
            'Yenileme numarası poliçelerde yer almasıyla birlikte sigortalıların bilgilerine kolay ulaşılmasını sağlar.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Sağlık sigortası poliçenizi iptal etmeye karar vermeden önce, maruz kalabileceğiniz sağlık harcamalarını iyice anladığınızdan emin olmalısınız. Poliçe iptali için sigortacınızla iletişime geçebilirsiniz.              ',
          subList: null
        },
        {
          paragraph:
            'Atmanız gereken adımları anlamak için poliçenizin iptal koşullarını kontrol edebilirsiniz. Çoğu şirket, bir sağlık planını iptal ederken onları doğrudan aramanızı ister.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortanızı taksitli ödeme seçeneğinden yararlanarak satın aldıysanız, günü gelen taksiti ödemediğinizde de poliçeniz iptal olacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası İptal Dilekçesi Örneği Nasıl Yazılır?',
      content: [
        {
          paragraph:
            'İptal dilekçesi yazmak isteyen sigortalılar öncelikle sigorta şirketine hitaben yazmalıdır.',
          subList: null
        },
        {
          paragraph: 'Dilekçede Sigortalının;',
          subList: [
            'Adı – Soyadı',
            'T.C. Kimlik Numarası - Vergi Kimlik Numarası',
            'Tüzel Kişi Ünvanı',
            'Poliçe Numarası',
            'Telefon Numarası',
            'İban'
          ]
        },
        {
          paragraph: 'Yer almalıdır.',
          subList: null
        },
        {
          paragraph:
            'Peşin ödenen sigorta poliçelerinde prim iadesi için IBAN bilgisi iletmeniz gerekmektedir. Dilekçenizi yazarak imzalayıp ilgili sigorta şirketine iletmeniz durumunda iptal işlemleriniz için size bilgi verilir.              ',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Tazminat Talep Formu Nedir?',
      content: [
        {
          paragraph:
            'Özel Sağlık Sigortası Tazminat Talep Formu, sigortalı bilgilerini içeren ve doktor tarafından doldurulan formdur.',
          subList: null
        },
        {
          paragraph:
            'Doktor, sigortalı hastanın bilgilerini eksiksiz ve doğru biçimde forma doldurmalıdır. Doldurulan form ilgili fatura ve tetkik sonuçları ile birlikte sigorta şirketine iletilmelidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Yabancılar İçin Özel Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Türkiye’de ikamet izni gerektiren sigorta türü olan yabancılar için sağlık sigortası, yabancıların ülkemizde sağlık hizmeti almalarını sağlar.              ',
          subList: null
        },
        {
          paragraph:
            'Yabancı sağlık sigortası yaptırılan sigorta şirketinin anlaşmalı hastanelerinden sigortalılar yararlanır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Yabancılar İçin Özel Sağlık Sigortası Fiyatları Nasıl Belirlenir?',
      content: [
        {
          paragraph: 'Yabancılar için sağlık sigortası fiyatları;',
          subList: [
            'Yaşa,',
            'Alınan Teminatlara,',
            'Hastalık Risklerine,',
            'Kullanılan İlaçlara,',
            'Sağlık Sorunlarına göre belirlenmektedir.'
          ]
        }
      ]
    },
    {
      title:
        'Özel Sağlık Sigortası Yaptırdıktan Ne Kadar Süre Sonra Ameliyat Olabilirim?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında sunulan bekleme süreleri sigorta şirketleri arasında değişiklik göstermektedir. İlk defa sigorta poliçesi satın alıyorsanız teminatların kapsamına dikkat etmeniz bu süreçte önemlidir. Ameliyat hizmetlerinden yararlanmak için verilen sürelerde poliçeden poliçeye değişebilir. Güncel poliçeniz varsa sigortacınızdan detaylı bilgi alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Estetik Ameliyatı Karşılıyor Mu?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında adaylar tarafından sıklıkla merak edilen “estetik” durumunu poliçeler karşılamamaktadır. Sağlık sigortası, sağlık sorunlarına karşı güvence sağlayan üründür.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Burun Ameliyatını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Sağlık sigortasında burun ameliyatının karşılanması değişiklik gösterebilir. Bu poliçe kapsamı ile ilgilidir. Genel olarak burun estetiği de poliçe kapsamında karşılanmaz.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Diş Tedavisini Karşılıyor Mu?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası diş kapsamı, özel sağlık sigortası diş implant karşılaması hizmetlerinden yararlanmak için sağlık sigortası satın alanların şirketin özel şartlarını incelemesi gerekmektedir.',
          subList: null
        },
        {
          paragraph:
            'Genel olarak diş tedavileri sağlık sigortası kapsamında yer almaz. Fakat bazı sigorta şirketleri diş paketi hizmeti verebilir. Bu sebeple 1 yıllık poliçe sürenizde diş hizmetlerinden yararlanmak istiyorsanız, satın alma aşamasında şartları ve hizmetleri incelemelisiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Tüp Bebeği Karşılıyor Mu?        ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında sunulan teminatlar ve hizmetler doğrultusunda tüp bebek hizmetleri karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Diyetisyeni Karşılar Mı?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında sunulan teminatlar ve hizmetler doğrultusunda diyetisyen hizmetleri karşılanmamaktadır. Poliçe ile sunulan hizmetler arasında bazı şirketler sağlık sigortası paketlerinde bir diyetisyen hakkı verebilir. Fakat tüm sigorta süreniz boyunca yapılacak işlemleri karşılamaz.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Tüp Mide Ameliyatı Karşılanır Mı?',
      content: [
        {
          paragraph:
            'Obezite ameliyatı olarak da bilinen tüp mide ameliyatı sağlık sigortası kapsamında karşılanmaz.',
          subList: null
        },
        {
          paragraph:
            'Kilo artışı kişide birçok sorunlara yol açarak, farklı hastalıkları da beraberinde getirmektedir. Aşırı kilolu olan kişilerin vücut kitle endeksi hesaplanarak son aşamada tüp mide ameliyatı olması zorunluysa, sağlık sigortası şirketiniz ile görüşme yaparak, karşılanma durumunu öğrenebilirsiniz.              ',
          subList: null
        },
        {
          paragraph:
            'Fakat isteğe bağlı tüp mide ameliyatı olmak isteyen sigortalıların masrafları bu poliçe kapsamında karşılanmayacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Psikolog Karşılar Mı?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamı sigorta şirketleri arası arasında farklılık göstermektedir. Sağlık poliçelerinde sunulan ana teminatlarından yanında ek teminat seçenekleri de ek prim karşılığında poliçeye alınabilir.              ',
          subList: null
        },
        {
          paragraph:
            'Yoğun tempolu çalışma hayatınız varsa sadece fiziksel rahatsızlıklar için poliçe almak yerine ana teminatları değerlendirerek psikolojik destek sunan teminata poliçenizde yer verebilirsiniz. Özel sağlık sigortası fiyatlarını karşılaştırırken ekstra sigorta şirketlerinin teminatlarını da karşılaştırmanız gerekir. Teminatlar arasında poliçenize psikolojik destek teminatı eklerseniz belli başlı işlemleriniz karşılanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Doğumu Karşılar Mı?        ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası doğum paketi ile doğum masraflarınızı karşılamanız mümkündür. Hamilelik planlayan anne adayları sağlık sigortasına yenileme zamanı doğum teminatı ekleyebilir. Sigorta şirketlerinin sunmuş olduğu doğum teminatı kapsamı farklılık gösterdiği gibi bekleme süreleri de farklılık göstermektedir.',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası poliçeniz hamilelik sırasında, doğum sırasında ve bebeğiniz doğduktan sonra mali destek sağlayabilir.',
          subList: null
        },
        {
          paragraph:
            'Bekleme süresi doğum teminatında özellikle önemlidir. Şirketler arası değişiklik gösteren bu süre 5 ay – 12 ay arası olabilmektedir. Örneğin, özel sağlık sigortası poliçenize eklediğiniz doğum teminatının bekleme süresi 12 ay ise, bu süre tamamlandıktan sonra gebelik başlamalıdır, aksi takdirde doğum giderleri karşılanmayacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Check Up Karşılar Mı?        ',
      content: [
        {
          paragraph:
            'Check-up teminatını sağlık sigortasının sunmuş olduğu faydalar arasına ekleyebiliriz.',
          subList: null
        },
        {
          paragraph:
            'Yılda 1 defa herkesin yaptırması gereken Check-up olası sağlık risklerine karşı erken önlem alınmasını ve teşhis konulmasını sağlar.',
          subList: null
        }
      ]
    },
    {
      title:
        'Deviasyon Ameliyatını Özel Sağlık Sigortası Karşılıyor Mu?        ',
      content: [
        {
          paragraph:
            'Nazal Septum Deviasyonu ve Konka Hastalıkları ile ilgili oluşan giderler sağlık sigortası poliçelerinde ilk yıl karşılanmamaktadır. Fakat sigorta poliçesini düzenli olarak yenileme yapan sigortalıların bu ameliyatı karşılatma durumu sigorta şirketinin şartlarına göre değişebilir.              ',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası poliçenizi düzenli olarak 2 - 3 yıl yenilemeniz durumunda <strong><em><u>nazal septum deviasyonu tedavisi</u></em></strong> kapsam dâhilinde olabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Sünneti Karşılar Mı?',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası kapsamında sünnet teminatı yer almamaktadır. Sünnet giderlerini karşılayan sigorta poliçesi arıyorsanız, tamamlayıcı sağlık sigortası fiyat teklifi alarak, detaylı bilgiye ulaşabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Özel Sağlık Sigortası İşten Ayrıldıktan Sonra Ne Kadar Devam Eder?        ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası yaptırmak için SGK şart aranmamaktadır. Bu nedenle özel sağlık sigortanızı kendiniz yaptırmışsanız, işten ayrıldıktan sonra poliçenizden yararlanmaya devam edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Fakat sağlık sigortanız, işveren aracılığıyla yaptırılmışsa işten ayrıldıktan sonra kurumunuz sağlık sigortanızı iptal edebilir. İptal edildikten sonra poliçenizden yararlanamazsınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Gözlük Hakkı Bulunur Mu?',
      content: [
        {
          paragraph:
            'Sağlık sigortası kapsamında sunulan göz teminatı şirketler arasında değişiklik göstermektedir. Fiyat karşılaştırması yaparken poliçenize ekletmek istediğiniz teminatları inceleyerek, özellikle istediğiniz teminatlar için sigorta uzmanlarına bilgi vermeniz gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Özel Sağlık Sigortası Vergi İndirimi Hesaplama Nasıl Yapılır?        ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası primlerini vergiden düşürerek poliçeye ödediğiniz ücretten avantaj elde edebilirsiniz. Sigortalı hem kendisi hem de ailesi için ödediği primler kapsamında vergi indirimden faydalanabilir.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası ya da tamamlayıcı sağlık sigortası için ödediğiniz primlerden, aylık brüt olarak ücretin %15’ini geçmeyecek miktarda, vergiden düşürerek yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi Özel Sağlık Sigortası Hangisi?',
      content: [
        {
          paragraph:
            'En iyi özel sağlık sigortası şirketi herkes için bir değildir. En iyi sağlık sigortası şirketi kişinin sağlık ihtiyaçlarına ve bütçesine göre farklılık göstermektedir. Size en doğru gelen poliçe ve şirket, başkası için aynı olmayabilir.',
          subList: null
        },
        {
          paragraph: 'İyi anlayışı, farklılık gösteren bir terimdir.',
          subList: null
        },
        {
          paragraph:
            'Sigorta şirketlerinin sunmuş olduğu tüm paketler kullanıcılara fayda sağlar. Önemli olan sizin için <strong><em>en iyi şirket hangisi?</em></strong> Bu sorunun cevabına ulaşabilmeniz içinde tüm şirketlerden fiyat alarak, karşılaştırma yapmanız gerekir.            ',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası primleri yaşla birlikte artar. Bu sebeple en iyi poliçenin yanı sıra en uygun özel sağlık sigortası fiyatlarına ulaşmak için <strong><em>erken yaşta sigorta poliçenizi</em></strong> yaptırmalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi Özel Sağlık Sigortası Nasıl Alınır?        ',
      content: [
        {
          paragraph:
            '“<strong>Hangi özel sağlık sigortası daha iyi</strong>” gibi merak ettiğiniz özel bir soru varsa, aşağıdaki adımları inceleyerek en iyi poliçeyi satın alabilirsiniz:',
          subList: [
            '1. Gerçekte kullanacağınız hizmetlerin kapsamını bulun.',
            '2. Ne kadar ve ne zaman talep edebileceğinizi öğrenin.',
            '3. İndirimler ve geri ödemeler hakkında araştırma yapın.',
            '4. Özel sağlık sigortasının vergiyi nasıl etkileyebileceğini öğrenin.',
            '5. Sağlık sigortasını seçerken hangi yaşam aşamasında olduğunuzu düşünün.',
            '6. Daha ekonomik hale getirmek için sağlığınıza dikkat edin.',
            '7. En doğru tercih için tüm şirketleri karşılaştırın.'
          ]
        }
      ]
    },
    {
      title:
        'Özel (Bireysel) Sağlık Sigortası Sorgulama Nereden Yapılır?          ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası fiyatı sorgulamak isteyen müşterilerimiz web sitemiz üzerinden teklif formunu doldurarak sorgulama yapabilir. Alokasko.com üzerinden talep edeceğiniz sağlık sigortası fiyatlarını karşılaştırarak, en iyi poliçeye ulaşabilmeniz için size branşında uzman danışman atanır. Böylece şirket karşılaştırmanızı yaparken zamandan ve fiyattan avantaj elde edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'En Uygun Özel Sağlık Sigortası Hesaplama Hangi Hususlara Göre Yapılır?          ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası fiyatı sorgulamak isteyen müşterilerimiz web sitemiz üzerinden teklif formunu doldurarak sorgulama yapabilir. Alokasko.com üzerinden talep edeceğiniz sağlık sigortası fiyatlarını karşılaştırarak, en iyi poliçeye ulaşabilmeniz için size branşında uzman danışman atanır. Böylece şirket karşılaştırmanızı yaparken zamandan ve fiyattan avantaj elde edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Sigorta primi, sigorta poliçesi için sigorta şirketine ödediğiniz para miktarıdır. Sigorta primleri için belirlenmiş bir maliyet yoktur. Özel sağlık sigortası fiyatları kişiye özel hazırlanır ve alınan kapsama göre değişiklik gösterir.              ',
          subList: [
            'Yaşınız',
            'Kapsam türünüz',
            'Teminat miktarınız',
            'Kişisel bilgileriniz',
            'Sağlık durumunuz göz önünde bulundurulur ve en uygun özel sağlık sigortası fiyatları belirlenir.'
          ]
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Karşılaştırma Nasıl Yapılır?          ',
      content: [
        {
          paragraph:
            'Özel sağlık sigortası, hastane masrafları dâhil olmak üzere çeşitli sağlık hizmeti seçeneklerini ve tıbbi harcamaları kapsayan bir sigorta poliçesi türüdür. Fiyat karşılaştırması yapmak için Alokasko.com web sitesinden teklif al formunu doldurmanız yeterlidir.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Neden sağlık sigortasını bizimle karşılaştırmalısınız?</em></u></strong>',
          subList: [
            'Karşılaştırmak çok kolay',
            'Mümkün olan en iyi hizmet',
            'Baştan sona branşında uzman danışman',
            'Taksitli ödeme ayrıcalığı.'
          ]
        },
        {
          paragraph:
            '*** Özel sağlık sigortasını karşılaştırmaya başlamak için iyi bir nokta, sizin için hangi faktörlerinin önemli olduğunu bulmak olabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Ücretleri (Primleri) Ne Kadar?        ',
      content: [
        {
          paragraph:
            'Mevcut plan türleri ve primler, yaşadığınız bölgeye ve yaşınıza göre değişiklik gösterecektir.',
          subList: null
        },
        {
          paragraph:
            'Özel sağlık sigortası fiyatlarını değerlendirmek için fiyat talebinde bulunmaz gerekir. Sigorta şirketine başvurana ve tıbbi geçmişinizi sağlayana kadar her ay gerçekte ne ödeyeceğinizi bilemezsiniz. Fiyatlandırma ve teminat türü, sağlık sigortası şirketine bağlı olarak önemli ölçüde değişebilir. Bu nedenle, hangi şirketin en iyi fiyat ve kapsam kombinasyonuna sahip olduğunu belirlemek için planları gerçekten karşılaştırmanız gerekir.            ',
          subList: null
        },
        {
          paragraph:
            'Hangi planların ihtiyaç duyduğunuz özelliklerin çoğunu sunduğunu ve sizin fiyat aralığınızda olduğunu belirlemek ve en iyi sigorta uzmanıyla çalışmak iyi bir fikir olabilir. Bir aile planı seçiyorsanız veya çalışanlarınıza sağlayacağınız bir planı seçen bir işverenseniz, plan kapsamında yer alacak kişilerinde ihtiyaçlarını göz önünde bulundurmak isteyeceksiniz.',
          subList: null
        },
        {
          paragraph: 'Bu zorlu süreçte en iyiyi seçebilmeniz için buradayız!',
          subList: null
        }
      ]
    },
    {
      title: 'Sağlık Sigortasının Maliyeti Neden Her Yıl Artıyor?        ',
      content: [
        {
          paragraph:
            'Basitçe söylemek gerekirse, sağlık sigortasının fiyatları, sağlık sisteminin artan maliyetine ayak uydurmalıdır.              ',
          subList: null
        },
        {
          paragraph:
            'Başlangıçta tüm hastane ve ekstra teminatların maliyeti aynı değildir, bu nedenle tüm artışlar aynı olmayacaktır. Yaşadığınız yer, sahip olduğunuz teminat türü ve seçtiğiniz herhangi bir fazlalık gibi çeşitli faktörler sağlık sigortasının maliyetini etkileyebilir.',
          subList: null
        },
        {
          paragraph:
            'Sigorta şirketleri tamamen risk değerlendirmesi ile ilgilidir. Risk ne kadar yüksekse, primler o kadar yüksek olur. Yine de primlerinizi düşürmenin yolları var.',
          subList: null
        },
        {
          paragraph:
            'Elbette, teminatınızı azaltırsanız paradan tasarruf edebilirsiniz; ancak bu her zaman iyi bir seçim değildir. Herhangi bir karar vermeden önce durumunuzu ve poliçeyi kullanma olasılığınızı değerlendirmeniz gerekir.            ',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Fiyatları Ortalama Ne Kadar?        ',
      content: [
        {
          paragraph:
            'Diğer birçok sigorta türü gibi, özel sağlık sigortasının maliyetleri de koşullarınıza ve satın alınan teminatın özelliklerine göre değişir. Benzer şekilde, yaşadığınız yerin tedavi maliyetleri ve dolayısıyla ödeyeceğiniz primler üzerinde dramatik bir etkisi olabilir. Primler de kaçınılmaz olarak yaşla birlikte artar.              ',
          subList: null
        },
        {
          paragraph:
            'Ortalama bir rakam verecek olursak, özel sağlık sigortası fiyatları <strong><em><u>1.000 ila 15.000 TL</u></em></strong> arasında farklılık gösterecektir. Bu tamamen poliçe kapsamına alınan kişi ve/veya kişilerle ilgilidir. Bunun dışında yaş, sağlık sigortası teminatları ve sağlık sorunlarınız primini belirleyecektir.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Fiyatları 2021 Ne Kadar?        ',
      content: [
        {
          paragraph:
            'Aylık primlerinizin maliyeti, özel sağlık sigortası şirketlerine ve teminatınızın ne kadar kapsamlı olduğuna bağlı olarak değişecektir.',
          subList: null
        },
        {
          paragraph:
            'En iyi fiyatı bulmak, ihtiyacınız olan teminatı içeren en uygun poliçeyi seçme meselesidir.',
          subList: null
        },
        {
          paragraph:
            'Her sigortacının, hangi tıbbi durumları ve tedaviyi kapsadıkları ve ne kadar prim talep edecekleri konusunda kendi kuralları olacaktır. Yalnızca ihtiyacınız olan poliçeler için ödeme yapmanızı ve bir sigorta talebinde bulunmanız durumunda ödenecek olan bir uzman danışmanla konuşmaya değer.              ',
          subList: null
        }
      ]
    },
    {
      title: 'Yeni Doğan Bebek Özel Sağlık Sigortası Fiyatları Nedir?        ',
      content: [
        {
          paragraph:
            'Hamilelik planlarken yeni doğacak bebeğiniz için sağlık sigortası araştırmaya başlamak iyi bir fikirdir. Hamileliğiniz sırasında aklınızda olabilecek birçok şey vardır. Bu endişelerden biri bebeğiniz için sağlık sigortası olabilir. Bu süreçte hastane masraflarını düşünmemenin tek yolu geniş kapsamlı bir poliçeye sahip olmaktır. Poliçenizi satın alıktan sonra ve bebeğinizin doğumundan 14 gün sonra yeni doğan teminatı ile bebeğinizi de sigorta kapsamına alabilirsiniz.              ',
          subList: null
        },
        {
          paragraph:
            'Poliçe fiyatları sigorta şirketlerine göre değişiklik gösterecektir. En doğru ve en güncel fiyatlar için teklif alabilirsiniz.              ',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Aile Paketi Fiyatları Ne Kadar?        ',
      content: [
        {
          paragraph:
            'Aile sağlık sigortası paketlerinin fiyatları, poliçe kapsamına alınan kişilere bağlıdır.',
          subList: null
        },
        {
          paragraph:
            'Bir aile sağlık sigortası planı bulmak istiyorsanız veya hangi tür sağlık planının sizin için doğru olduğunu bulmak istiyorsanız ve yardıma ihtiyacınız varsa, <strong><em><u>AloKasko sizin için burada.</u></em></strong>',
          subList: null
        },
        {
          paragraph:
            'Karşılaştırma aracıyla en uygun fiyatlı planları karşılaştırın veya uzman bir temsilciyle çevrimiçi veya telefonla bugün konuşun.',
          subList: null
        }
      ]
    },
    {
      title: 'Özel Sağlık Sigortası Aylık Ne Kadar?        ',
      content: [
        {
          paragraph:
            'Sağlık sigortası ile poliçeniz için kararlaştırılan aylık bir ücret ödersiniz. Bu, sizi cebinizden çıkarabilecek beklenmedik sağlık masraflarıyla karşılaşmak yerine, tıbbi ihtiyaçlarınız için önceden bütçe yapmanızı sağlar.              ',
          subList: null
        },
        {
          paragraph:
            'Her sigortacı kendi ücretlerini ve şartlarını belirler, bu nedenle bir sağlık sigortası almak, yalnızca ihtiyacınız olabilecek her şeyi kapsayan bir poliçe bulabilirseniz faydalı olacaktır.',
          subList: null
        },
        {
          paragraph:
            'Aylık ödemeniz gereken ücret ise poliçe primi üzerinden taksitlendirilecektir. Bu sebeple net tutarı görüntülemek için teklif alabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
